import { render, staticRenderFns } from "./TheMenu.vue?vue&type=template&id=aa9766bc&scoped=true&"
import script from "./TheMenu.vue?vue&type=script&lang=js&"
export * from "./TheMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9766bc",
  null
  
)

export default component.exports